// extracted by mini-css-extract-plugin
export default {"colors":"'../../styles/colors.module.css'","blue-050":"#e3f2ff","blue050":"#e3f2ff","blue-background":"Asset_blue-background__tzyZb","blueBackground":"Asset_blue-background__tzyZb"};